<template>
  <div id="app">
    <!-- 头部 -->
    <el-header class="header">
      <div class="header-content">
        <div class="logo" @click="$router.push('/')">
          <img class="logo-image" :src="logoImg" alt="站点Logo" />
          <span>鲁班在线工具</span>
        </div>
        <div class="auth-buttons">
          <el-button type="text" @click="loginDialogVisible = true">登录</el-button>
          <el-button type="primary" size="small" @click="registerDialogVisible = true">注册</el-button>
        </div>
      </div>
    </el-header>

    <!-- 导航栏 -->
    <div class="nav-container">
      <el-menu :default-active="activeMenu" class="el-menu-demo" mode="horizontal" @select="handleSelect"
        background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" router>
        <el-menu-item index="/" :route="{ path: '/' }">
          <i class="el-icon-s-grid"></i>
          <span>二维码生成</span>
        </el-menu-item>
        <el-menu-item index="/batch-qrcode" :route="{ path: '/batch-qrcode' }">
          <i class="el-icon-s-data"></i>
          <span>批量生成</span>
        </el-menu-item>
        <el-menu-item index="2">
          <i class="el-icon-picture-outline"></i>
          <span>图片处理</span>
        </el-menu-item>
        <el-menu-item index="3">
          <i class="el-icon-document"></i>
          <span>文档转换</span>
        </el-menu-item>
        <el-menu-item index="4">
          <i class="el-icon-date"></i>
          <span>时间工具</span>
        </el-menu-item>
        <el-menu-item index="5">
          <i class="el-icon-link"></i>
          <span>网络工具</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 路由视图 -->
    <router-view class="main-container"></router-view>

    <!-- 页脚 -->
    <el-footer class="footer">
      <!-- 主要页脚内容 -->
      <div class="footer-main">
        <div class="footer-content">
          <el-row :gutter="30">
            <!-- 关于鲁班 -->
            <el-col :span="8">
              <div class="footer-section">
                <h3>关于鲁班</h3>
                <div class="footer-logo">
                  <img class="footer-logo-image" :src="footerLogoImg" alt="Footer Logo" />
                  <span>鲁班工具集</span>
                </div>
                <p>专业的在线工具平台，让工作变得更简单高效。</p>
                <div class="social-links">
                  <a href="#" title="微信"><i class="el-icon-chat-dot-round"></i></a>
                  <a href="#" title="微博"><i class="el-icon-share"></i></a>
                  <a href="#" title="GitHub"><i class="el-icon-link"></i></a>
                  <a href="#" title="邮箱"><i class="el-icon-message"></i></a>
                </div>
              </div>
            </el-col>

            <!-- 工具分类 -->
            <el-col :span="8">
              <div class="footer-section">
                <h3>工具分类</h3>
                <ul class="footer-links">
                  <li><a href="#"><i class="el-icon-s-grid"></i> 二维码生成</a></li>
                  <li><a href="#"><i class="el-icon-s-data"></i> 批量生成</a></li>
                  <li><a href="#"><i class="el-icon-picture-outline"></i> 图片处理</a></li>
                  <li><a href="#"><i class="el-icon-document"></i> 文档转换</a></li>
                </ul>
              </div>
            </el-col>

            <!-- 联系信息 -->
            <el-col :span="8">
              <div class="footer-section">
                <h3>联系我们</h3>
                <div class="contact-info">
                  <div class="contact-item">
                    <i class="el-icon-phone"></i>
                    <div>
                      <strong>客服热线</strong>
                      <p>18362214816</p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <i class="el-icon-message"></i>
                    <div>
                      <strong>商务邮箱</strong>
                      <p>739226773@qq.com</p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <i class="el-icon-time"></i>
                    <div>
                      <strong>服务时间</strong>
                      <p>工作日 9:00-18:00</p>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 页脚底部 -->
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <div class="copyright">
            <!-- <p>&copy; 2025 张家港鲁班互联网公司. 保留所有权利.</p> -->
          </div>
          <!-- 添加备案号 -->
          <div class="beian">
            <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">苏ICP备2024131967号-2</a>
          </div>

          <!-- <div class="footer-bottom-links">
            <a href="#">服务条款</a>
            <a href="#">隐私政策</a>
            <a href="#">联系我们</a>
          </div> -->
        </div>
      </div>
    </el-footer>

    <!-- 登录对话框 -->
    <el-dialog title="用户登录" :visible.sync="loginDialogVisible" width="30%">
      <el-form :model="loginForm" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="loginForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input type="password" v-model="loginForm.password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="loginDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleLogin">登 录</el-button>
      </div>
    </el-dialog>

    <!-- 注册对话框 -->
    <el-dialog title="用户注册" :visible.sync="registerDialogVisible" width="30%">
      <el-form :model="registerForm" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="registerForm.username"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="registerForm.email"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input type="password" v-model="registerForm.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input type="password" v-model="registerForm.confirmPassword"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="registerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleRegister">注 册</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
  import logoImg from '@/assets/logo.png'
  import footerLogoImg from '@/assets/logo.svg'
  export default {
    name: 'App',
    data () {
      return {
        logoImg,
        footerLogoImg,
        activeMenu: '/',
        loginDialogVisible: false,
        registerDialogVisible: false,

        loginForm: {
          username: '',
          password: ''
        },
        registerForm: {
          username: '',
          email: '',
          password: '',
          confirmPassword: ''
        }
      }
    },
    watch: {
      $route: {
        handler (to) {
          this.activeMenu = to.path
        },
        immediate: true
      }
    },
    methods: {
      handleSelect (key, keyPath) {
        console.log(key, keyPath)
        this.activeMenu = key
      },
      handleLogin () {
        this.$message.success('登录功能待开发')
        this.loginDialogVisible = false
      },
      handleRegister () {
        this.$message.success('注册功能待开发')
        this.registerDialogVisible = false
      }
    }
  }
</script>

<style>
  :root {
    --brand-primary: #0091EA;
    --brand-primary-dark: #006bb3;
    --brand-accent: #12b9ff;
    --brand-gradient-start: #007ad9; /* 统一纯蓝系 */
    --brand-gradient-end: #004b92;
    --brand-bg-soft: #f5f9fc;
    --brand-nav-bg: #063357;
    --brand-nav-separator: #0d4a7d;
    --brand-header-shadow: 0 2px 6px rgba(0,0,0,0.08);
  }
  /* 头部使用品牌蓝纯渐变 + 阴影 */
  /* .header { background: linear-gradient(90deg,var(--brand-gradient-start),var(--brand-gradient-end)); box-shadow: var(--brand-header-shadow); } */
  /* 去掉旧的紫色重复定义 (覆盖) */
  /* 导航容器与菜单 */
  .nav-container { background: var(--brand-nav-bg); box-shadow: inset 0 -1px 0 var(--brand-nav-separator); }
  .el-menu-demo { background: transparent !important; }
  .el-menu--horizontal>.el-menu-item { border-bottom: 2px solid transparent; }
  .el-menu--horizontal>.el-menu-item.is-active { border-bottom-color: var(--brand-accent) !important; color: #fff !important; }
  .el-menu--horizontal>.el-menu-item:hover { color: var(--brand-accent) !important; }
  /* 文字按钮颜色保持一致 */
  .auth-buttons .el-button--text { color: #333; }
  .logo span { color:#333; }

  /* 页面背景柔和化 */
  body, #app { background: var(--brand-bg-soft); }

  /* 导航栏背景 & 交互 */
  .nav-container { background: var(--brand-nav-bg); }
  .el-menu-demo { background: var(--brand-nav-bg) !important; }
  .el-menu--horizontal>.el-menu-item {
    background: transparent !important;
  }

  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom-color: var(--brand-accent) !important;
    color: var(--brand-accent) !important;
  }

  .el-menu--horizontal>.el-menu-item:hover {
    color: var(--brand-accent) !important;
  }

  /* 页脚渐变同步 */
  .footer, .footer::before {
    background: linear-gradient(135deg, var(--brand-gradient-start) 0%, var(--brand-gradient-end) 100%) !important;
  }

  .footer-logo { color: var(--brand-accent); }
  .footer-links a i { color: var(--brand-primary); }
  .social-links a:hover { background: var(--brand-primary); }

  /* 主内容区阴影/卡片背景可根据需要统一 */
  .el-card { border-color: #e3eef5; }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  /* 头部样式 */
  .header {
    /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
    color: #333;
    padding: 0;
    height: 60px !important;
    line-height: 60px;
  }

  .header-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 20px;
  }

  .logo {
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: color 0.3s;
  }

  .logo:hover {
    color: #ffd04b;
  }

  .logo-image {
    height: 34px;
    width: auto;
    margin-right: 10px;
    display: block;
  }

  .auth-buttons .el-button--text {
    color: #333;
  }

  /* 导航栏样式 */
  .nav-container {
    display: flex;
    justify-content: center;
    background-color: #545c64;
  }

  .el-menu-demo {
    max-width: 1200px;
    width: 100%;
    justify-content: center;
  }

  .el-menu--horizontal>.el-menu-item {
    height: 60px;
    line-height: 60px;
    border-bottom: 2px solid transparent;
  }

  .el-menu--horizontal>.el-menu-item:hover,
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom-color: #ffd04b;
  }

  /* 主要内容区域 */
  .main-container {
    flex: 1;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    width: 100%;
  }

  /* 页脚样式 */
  .footer {
    background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
    color: white;
    margin-top: auto;
    padding: 0;
    height: auto !important;
    /* 覆盖 Element UI 的默认高度 */
    min-height: auto;
    width: 100%;
    position: relative;
  }

  .footer::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
    z-index: 0;
  }

  .footer>* {
    position: relative;
    z-index: 1;
  }

  /* 主要页脚内容 */
  .footer-main {
    padding: 40px 0;
    width: 100%;
  }

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .footer-section {
    margin-bottom: 20px;
    height: 100%;
  }

  .footer-section h3 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #ecf0f1;
    padding-bottom: 8px;
    border-bottom: 2px solid #3498db;
    display: inline-block;
  }

  /* Logo 区域 */
  .footer-logo {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: bold;
    color: #3498db;
  }

  .footer-logo-image {
    height: 30px;
    width: auto;
    margin-right: 10px;
    display: block;
  }

  .footer-section p {
    line-height: 1.6;
    color: #bdc3c7;
    margin-bottom: 15px;
    font-size: 14px;
  }

  /* 社交媒体链接 */
  .social-links {
    display: flex;
    gap: 10px;
  }

  .social-links a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    color: white;
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 16px;
  }

  .social-links a:hover {
    background: #3498db;
    transform: translateY(-2px);
  }

  /* 页脚链接列表 */
  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .footer-links li {
    margin-bottom: 8px;
  }

  .footer-links a {
    color: #bdc3c7;
    text-decoration: none;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    padding: 4px 0;
    font-size: 14px;
  }

  .footer-links a i {
    margin-right: 8px;
    width: 16px;
    color: #3498db;
  }

  .footer-links a:hover {
    color: #3498db;
    padding-left: 5px;
  }

  /* 联系信息 */
  .contact-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 15px;
  }

  .contact-item i {
    font-size: 16px;
    color: #3498db;
    margin-right: 10px;
    margin-top: 2px;
    min-width: 18px;
  }

  .contact-item div strong {
    display: block;
    color: #ecf0f1;
    font-weight: bold;
    margin-bottom: 3px;
    font-size: 14px;
  }

  .contact-item div p {
    color: #bdc3c7;
    margin: 0;
    line-height: 1.4;
    font-size: 13px;
  }

  /* 页脚底部 */
  .footer-bottom {
    background: rgba(0, 0, 0, 0.3);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 15px 0;
    width: 100%;
  }

  .footer-bottom-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
  }

  .copyright {
    flex: 1;
  }

  .copyright p {
    margin: 0;
    color: #bdc3c7;
    font-size: 14px;
    line-height: 1.4;
  }

  .footer-bottom-links {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
  }

  .footer-bottom-links a {
    color: #bdc3c7;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s ease;
    position: relative;
  }

  .footer-bottom-links a:hover {
    color: #3498db;
  }

  .footer-bottom-links a:not(:last-child)::after {
    content: "|";
    position: absolute;
    right: -8px;
    color: #7f8c8d;
  }

  /* 响应式设计 */
  @media (max-width: 768px) {

    .header-content,
    .footer-content {
      flex-direction: column;
      height: auto;
      padding: 10px;
    }

    .logo {
      margin-bottom: 10px;
    }

    .main-container {
      padding: 10px;
    }

    /* 页脚响应式 */
    .footer-main {
      padding: 30px 0;
    }

    .footer-content {
      padding: 0 15px;
    }

    .footer-section h3 {
      font-size: 16px;
      margin-bottom: 15px;
    }

    .footer-section {
      margin-bottom: 25px;
      text-align: center;
    }

    .footer-bottom-content {
      flex-direction: column;
      text-align: center;
      gap: 10px;
      padding: 0 15px;
    }

    .footer-bottom-links {
      justify-content: center;
      gap: 10px;
    }

    .footer-bottom-links a:not(:last-child)::after {
      right: -6px;
    }

    .contact-item {
      margin-bottom: 12px;
      justify-content: center;
    }

    .social-links {
      justify-content: center;
    }

    .footer-logo {
      justify-content: center;
      font-size: 16px;
    }
  }
  .beian a {
    color: #bdc3c7;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s ease;
  }
  /* 兼容旧样式：去掉 .logo i 的占位 */
  .logo i, .footer-logo i { display: none; }
</style>